var map = {
	"./1.jpg": 96963,
	"./10.jpg": 52133,
	"./11.jpg": 85619,
	"./12.jpg": 77553,
	"./13.jpg": 34174,
	"./14.jpg": 92225,
	"./15.jpg": 55474,
	"./16.jpg": 22831,
	"./17.jpg": 30567,
	"./18.jpg": 82917,
	"./19.jpg": 92161,
	"./1_old.jpg": 59312,
	"./1st floor-ip-department-9.png": 14817,
	"./2.jpg": 87607,
	"./20.jpg": 12074,
	"./21.jpg": 73978,
	"./22.jpg": 13737,
	"./23.jpg": 75380,
	"./24.jpg": 53197,
	"./25.jpg": 19,
	"./26.jpg": 59471,
	"./27.jpg": 18314,
	"./28.jpg": 64174,
	"./29.jpg": 20152,
	"./2nd-floor-ip-department-10.png": 39601,
	"./3.jpg": 28242,
	"./30.jpg": 26689,
	"./4.jpg": 99918,
	"./5.jpg": 98204,
	"./6.jpg": 15125,
	"./7.jpg": 77495,
	"./8.jpg": 84113,
	"./9.jpg": 15828,
	"./Baby Shop.jpg": 95923,
	"./HDU.jpg": 2795,
	"./InPatient Area.jpg": 62784,
	"./InPatient Lobby.jpg": 64522,
	"./LDU.jpg": 12235,
	"./Main Lobby.jpg": 75087,
	"./Neonatal Transport Incubator.jpg": 5210,
	"./Operation Theatre.jpg": 31059,
	"./Outpatient Department.jpg": 66422,
	"./Private Room.jpg": 15154,
	"./Radiology.jpg": 46793,
	"./Reception.jpg": 12153,
	"./SICU.jpg": 67368,
	"./Semi Suit Room.jpg": 39130,
	"./Suit Room.jpg": 17342,
	"./baby-shop-4.png": 56190,
	"./bangalore-old.jpg": 85635,
	"./bangalore.jpg": 93043,
	"./chili-pili-banner.jpg": 35173,
	"./clinics-banner.jpg": 73475,
	"./conference-room-bng-1.png": 73018,
	"./dental.jpg": 99851,
	"./dentistry-banner.webp": 78148,
	"./diamond-12.png": 8676,
	"./fertility-old.jpg": 2485,
	"./fertility.jpg": 41383,
	"./first-foot-imprint-ban.jpg": 27028,
	"./first-foot-imprint-mys.jpg": 73800,
	"./hospital-1.png": 47088,
	"./hospital-bng.jpg": 9225,
	"./kids-banner.png": 29371,
	"./kids-web-banner.jpg": 38922,
	"./main-lobby-2.png": 67224,
	"./mysore-new/1st floor-OPdepartment.png": 34558,
	"./mysore-new/Your paragraph text (13).jpg": 88257,
	"./mysore-new/Your paragraph text (19).jpg": 96499,
	"./mysore-new/Your paragraph text (5).jpg": 60608,
	"./mysore-new/Your paragraph text.jpg": 64406,
	"./mysore-new/aerobic-3391.jpg": 32887,
	"./mysore-new/baby-shop-and-himalaya-3265.jpg": 51892,
	"./mysore-new/cafeteria.png": 75470,
	"./mysore-new/first-floor-ip-department-9590.jpg": 56698,
	"./mysore-new/first-floor-op-department-3315.jpg": 80187,
	"./mysore-new/hospital.png": 80520,
	"./mysore-new/lab-9638.jpg": 74529,
	"./mysore-new/library-9624.jpg": 21977,
	"./mysore-new/main-lobby-3257.jpg": 4450,
	"./mysore-new/nicu-in-born-3492.jpg": 81867,
	"./mysore-new/nicu-outborn-3484.jpg": 35914,
	"./mysore-new/obg-opd-3286.jpg": 37844,
	"./mysore-new/obg-opd.png": 11255,
	"./mysore-new/opd-9544.jpg": 27202,
	"./mysore-new/pharmacy.png": 40882,
	"./mysore-new/radiology-9559.jpg": 66258,
	"./mysore-new/reception-3273.jpg": 59276,
	"./mysore-new/reception.png": 53006,
	"./mysore-new/second-floor-ip-department-9608.jpg": 43919,
	"./mysore-new/sicu-3375.jpg": 97594,
	"./mysore-new/triage-3414.jpg": 47395,
	"./mysore-new/twin-sharing-3512.jpg": 53888,
	"./mysore-new/yoga-room.png": 43358,
	"./mysore.jpg": 93501,
	"./nescafe.jpg": 19541,
	"./nicu-21.png": 64717,
	"./nicu.jpg": 92297,
	"./obg-opd-7.png": 32566,
	"./operation-theater-17.png": 33913,
	"./paediatric-opd-8.png": 89402,
	"./pharmacy-6.png": 51660,
	"./photo-studio.jpg": 69093,
	"./ramanagar-banner.jpg": 55916,
	"./ramanagar-banner1.jpg": 20466,
	"./ramanagara/inside-hospital.jpg": 76078,
	"./ramanagara/lobby-1.jpg": 60150,
	"./ramanagara/lobby-2.jpg": 15293,
	"./ramanagara/main-entrance.jpg": 23188,
	"./ramanagara/main-gate.jpg": 15115,
	"./ramanagara/main-reception.jpg": 96979,
	"./ramanagara/main_entrance.jpg": 76963,
	"./ramanagara/main_gate.jpg": 6668,
	"./ramanagara/new/IP-department.png": 20447,
	"./ramanagara/new/NICU.png": 4107,
	"./ramanagara/new/OBG-OPD.png": 739,
	"./ramanagara/new/SICU-&-HDU.png": 64920,
	"./ramanagara/new/aerobics-room.jpg": 67846,
	"./ramanagara/new/baby-shop.jpg": 33265,
	"./ramanagara/new/baby-shop.png": 63251,
	"./ramanagara/new/cafeteria.jpg": 3687,
	"./ramanagara/new/cafeteria.png": 63882,
	"./ramanagara/new/conference-room.jpg": 46434,
	"./ramanagara/new/doctors-lounge.jpg": 4256,
	"./ramanagara/new/first-foot-imprint-ram.jpg": 17324,
	"./ramanagara/new/first-imprints.jpg": 56977,
	"./ramanagara/new/hospital.jpg": 11646,
	"./ramanagara/new/hospital.png": 90889,
	"./ramanagara/new/ip-biling.jpg": 62434,
	"./ramanagara/new/laboratory.jpg": 47425,
	"./ramanagara/new/main-lobby.jpg": 85514,
	"./ramanagara/new/nicu.jpg": 20048,
	"./ramanagara/new/nursing-station.jpg": 30945,
	"./ramanagara/new/nursing-station.png": 9376,
	"./ramanagara/new/obg-opd.jpg": 20860,
	"./ramanagara/new/ot.jpg": 68342,
	"./ramanagara/new/peadiatrics-opd.jpg": 61104,
	"./ramanagara/new/pharmacy.jpg": 58642,
	"./ramanagara/new/photo-studio-ram.jpg": 17995,
	"./ramanagara/new/platinumroom.png": 35504,
	"./ramanagara/new/private-room.jpg": 76093,
	"./ramanagara/new/radiology.jpg": 30721,
	"./ramanagara/new/radiology.png": 37169,
	"./ramanagara/new/reception.jpg": 34350,
	"./ramanagara/new/shared-room.jpg": 48909,
	"./ramanagara/new/sicu.jpg": 50334,
	"./ramanagara/new/studio.jpg": 30937,
	"./ramanagara/new/suite-room.jpg": 88533,
	"./ramanagara/new/triage.jpg": 45396,
	"./ramanagara/new/triage.png": 94770,
	"./ramanagara/our-journey.jpg": 56265,
	"./ramanagara/reception.jpg": 33398,
	"./ramanagara/ward-room.jpg": 81015,
	"./ramanagara/ward.jpg": 59178,
	"./ramnagar-1.jpg": 52318,
	"./ramnagar-2.jpg": 42113,
	"./ramnagar-3.jpg": 54823,
	"./ramnagar-4.jpg": 24167,
	"./ramnagar-5.jpg": 95094,
	"./ramnagar-6.jpg": 44006,
	"./ramnagar-7.jpg": 82362,
	"./ramnagar-8.jpg": 65050,
	"./ramnagar_banner.jpg": 40779,
	"./reception-3.png": 47993,
	"./triage-5.png": 64722,
	"./tumakuru/Baby Shop.jpg": 10601,
	"./tumakuru/Hospital.jpg": 47164,
	"./tumakuru/Kids .jpg": 64662,
	"./tumakuru/NICU.jpg": 90849,
	"./tumakuru/Private.jpg": 56585,
	"./tumakuru/Reception.jpg": 36683,
	"./tumakuru/SICU.jpg": 8293,
	"./tumakuru/Semi Suite.jpg": 62655,
	"./tumakuru/Suite .jpg": 90966,
	"./tumakuru/Tumakuru Cafeteria.jpg": 83325,
	"./tumakuru/labour.jpg": 70241,
	"./tumakuru/operation theater .jpg": 72904,
	"./tumakuru/studio.JPEG": 8093,
	"./tumakuru/twin-sharing..jpg": 85189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;